// No browser except Safari can decode HEIC/HEIF (iPhone "High Efficiency"
// photos), so a HEIC chat attachment renders as a broken thumbnail for
// everyone else (PROD-1449). The worker app converts before upload; this
// guard covers admin-side uploads, where the browser cannot transcode.
export function isLikelyHeic(file: { name?: string; type?: string }): boolean {
  if (file.type && /^image\/hei[cf]$/i.test(file.type)) return true;
  return /\.hei[cf]$/i.test(file.name ?? '');
}
